import React from 'react';

import {Period} from '@/widgets/Period';

export const MonthPeriod = () => <Period />;
